import React, { createContext, useContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

  const login = (userData) => {
    const { id, pseudo, role, token } = userData;
    const safeUserData = { id, pseudo, role, token }; 
    localStorage.setItem("user", JSON.stringify(safeUserData));
    setUser(safeUserData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const getApiBaseUrl = () => {
    return user?.role === "ADMIN"
      ? process.env.REACT_APP_API_ADMIN_URL
      : process.env.REACT_APP_API_USER_URL;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, getApiBaseUrl }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);